import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import FinancialSummary from "components/Accounts/MISReports/ActualP&L/newP&LSummary";
export default function TotalIncomeStatement() {
  return <DashboardLayout></DashboardLayout>;
}
